import message from 'antd/lib/message'
require('antd/lib/message/style')

export default {
  success (content, duration, onClose) {
    return setTimeout(() => message.success(content, duration, onClose))
  },
  error (content, duration, onClose) {
    return setTimeout(() => message.error(content, duration, onClose))
  },
  info (content, duration, onClose) {
    return setTimeout(() => message.info(content, duration, onClose))
  },
  warning (content, duration, onClose) {
    return setTimeout(() => message.warning(content, duration, onClose))
  },
  loading (content, duration, onClose) {
    return setTimeout(() => message.loading(content, duration, onClose))
  }
}
